import { render, staticRenderFns } from "./SysRole.vue?vue&type=template&id=60b981eb&scoped=true&"
import script from "./SysRole.vue?vue&type=script&lang=js&"
export * from "./SysRole.vue?vue&type=script&lang=js&"
import style0 from "./SysRole.vue?vue&type=style&index=0&id=60b981eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b981eb",
  null
  
)

export default component.exports